import { FC, PropsWithChildren } from "react";

export const HotspotDots: FC<PropsWithChildren> = ({ children }) => {
	return <>{children}</>;
};
